/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, May 2023
 * @format
 * @flow
 */

import React from 'react';
import { Box } from '@material-ui/core';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import BodyWithActions from './BodyWithActions';

const Body = props => {
    const { assignTableMode, showTableProperties } = props;

    if (assignTableMode || showTableProperties) {
        return (
            <Box>
                <BodyWithActions {...props} />
            </Box>
        )
    }

    return (
        <Box display={'flex'} flexDirection={'row'} height={'100%'}>
            <Box width={'30%'}>
                <LeftSection {...props} />
            </Box>
            <Box width={'70%'}>
                <RightSection {...props} />
            </Box>
        </Box>
    );
};

export default Body;
